import React from "react";
import { Box, Text, Image } from "@chakra-ui/react";
import moment from "moment";
import useLoader from "../../loader/loaderstates";
import Loader from "../../loader/loader";
import {Toaster } from "../../../components";
import { SaveInvestigationToPrescription } from "../../../middleware/services/vitalschart";


const statusColorMap = {
  Ok: "green.500",
  Low: "orange.300",
  High: "red.500",
};

const statusIconMap = {
  Ok: "/assets/svgs/ok.svg",
  Normal: "/assets/svgs/ok.svg",
  Low: "/assets//svgs/low.svg",
  High: "/assets//svgs/high.svg",
};

const formatDate = (dateString) => {
  if (!dateString) return "-";
  return moment(dateString).format("Do MMM, YYYY");
};

const InvestigationsDisplayCard = ({
  id,
  appointmentId,
  vitalName,
  vitalValue,
  vitalUnit,
  vitalDate,
  vitalStatus,
  status,
  trendColor
}) => {
  const statusColor = statusColorMap[vitalStatus] || "gray.500";
  const statusIcon = statusIconMap[vitalStatus] || "";
  const { isLoading, showLoader, dismissLoader } = useLoader();
  const { showSuccessToast, showErrorToast } = Toaster();
  // console.log(status, trendColor)
  const addtoprescription = async () => {
    let input = { "id": id, "appointmentid": appointmentId }
    try {
      const result = await SaveInvestigationToPrescription(input);
      // console.log(result)
      if (result) {
        showSuccessToast("Added to Prescription");
      } else {
        console.log(result.output.result);
        showErrorToast("Something went wrong!");
      }
    } catch (error) {
      console.error("Error in delete documents:", error);
    }
  };
  return (
    <Box
      border="1px"
      borderColor="#E6E7E9"
      borderRadius="md"
      p={4}
      minW="8.75rem"
      backgroundColor={"white"}
    >
      <Text fontSize="12px" fontWeight="500" color="#6A707D">
        {vitalName}
      </Text>
      <Box display="flex" alignItems="center" justifyContent="space-between">
      {/* Value and Unit vertically stacked on the left */}
      <Box display="flex" flexDirection="column" alignItems="flex-start">
        <Text fontSize={{ base: "18px", md: "22px" }} fontWeight="600">
          {vitalValue}
        </Text>
        <Text fontSize={{ base: "12px", md: "15px" }} fontWeight="400">
          {vitalUnit}
        </Text>
      </Box>

      {/* Button on the right */}
      <Box
        as="button"
        w="50%"
        border="1px solid #E6E7E9"
        p="10px"
        borderRadius="10px"
        mt="0" // removed margin-top to align in a row
        height="50px"
        display="flex"
        alignItems="center"
        justifyContent="center"
        onClick={addtoprescription}
      >
        <Box
          display="flex"
          fontSize="12px"
          flexDirection="column"
          justifyContent="center"
          fontWeight="500"
        >
          Add to prescription
        </Box>
      </Box>
    </Box>

      <Box
        display="flex"
        justifyContent="space-between"
        alignItems="center"
        mt="0.5rem"
      >
        <Text fontSize="12px" fontWeight="500" color="#6A707D">
          {formatDate(vitalDate)}
        </Text>
        {/* <Box display="flex" alignItems="center" gap="0.25rem">
          {statusIcon && <Image w="12px" h="auto" src={statusIcon} />}
          <Text as="span" fontSize="12px" fontWeight="600" color={statusColor}>
            {vitalStatus}
          </Text>
        </Box> */}
        {status === "low" &&
        trendColor === "red" ? (
          <Box display="flex" alignItems="center" transform="scaleY(-1)">
            <Image
              w="12px"
              h="auto"
              src="/assets/imgs/red-chart.png"
              alt="Normal"
            />
          </Box>
        ) : status === "high" &&
          trendColor === "red" ? (
          <Box display="flex" alignItems="center">
            <Image
              w="12px"
              h="auto"
              src="/assets/imgs/red-chart.png"
              alt="Normal"
            />
          </Box>
        ) : status === "low" &&
          trendColor === "green" ? (
          <Box display="flex" alignItems="center">
            <Image
              w="12px"
              h="auto"
              src="/assets/imgs/green-chart.png"
              alt="Normal"
            />
          </Box>
        ) : status === "high" &&
          trendColor === "green" ? (
          <Box display="flex" alignItems="center" transform="scaleY(-1)">
            <Image
              w="12px"
              h="auto"
              src="/assets/imgs/green-chart.png"
              alt="Normal"
            />
          </Box>
        ) : null}
      </Box>
    </Box>
  );
};

export default InvestigationsDisplayCard;
